/**
 * @desc sku修改(保存草稿)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMasterResponseDto>;
export function request(body: defs.basics.ProductSkuRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
